import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
    name: 'establishment/session',
    initialState: {
        token: '',
        signedIn: false
    },
    reducers: {
        onEstablishmentSignInSuccess: (state, action) => {
            state.signedIn = true
            state.token = action.payload
        },
        onEstablishmentSignOutSuccess: (state) => {
            state.signedIn = false
            state.token = ''
        },
        setToken: (state, action) => {
            state.token = action.payload
        }
    }
})

export const { onEstablishmentSignInSuccess, onEstablishmentSignOutSuccess, setToken } = sessionSlice.actions

export default sessionSlice.reducer
